/*
  Copyright 2018 Google LLC

  Use of this source code is governed by an MIT-style
  license that can be found in the LICENSE file or at
  https://opensource.org/licenses/MIT.
*/
import { CacheExpiration } from './CacheExpiration.js';
import { ExpirationPlugin } from './ExpirationPlugin.js';
import './_version.js';
/**
 * @module workbox-expiration
 */
export { CacheExpiration, ExpirationPlugin };
